import { useMutation, useQueryClient } from '@tanstack/react-query';

import { API_ROUTES } from '@/query/routes';
import axiosInstance from '@/utils/api/axios-instance';

const logoutUser = async () => {
  await axiosInstance.post(API_ROUTES.logout());
};

const useLogout = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: logoutUser,

    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['me'] });
    },
    onError: (error) => {
      console.error('Logout failed:', error);
    },
  });
};

export default useLogout;
